import Link from 'next/link';
import cn from 'classnames';
import styled from 'styled-components';
import Image from 'next/image';

const contentfulLoader = ({ src, width, quality }) => {
  return `${src}?w=${width}&q=${quality || 75}`;
};

const CoverImageWrapper = styled.div`
  margin: auto;
  span {
    position: relative !important;
    height: 100% !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 250ms, transform 250ms;
    img {
      &:hover {
        background-position: 100% 100%;
      }

      border-radius: 13px;
      object-fit: cover;
    }
  }
`;

const CoverImageImg = (props) => {
  return (
    <CoverImageWrapper>
      <Image loader={contentfulLoader} {...props} />
    </CoverImageWrapper>
  );
};

export default function CoverImage({ title, url, slug, width, height, link }) {
  const image = url ? (
    <div className="sm:max-w-xl md:max-w-4xl lg:max-w-5xl mx-auto">
      <CoverImageImg
        alt={`Cover Image for ${title}`}
        className={cn('mx-auto shadow-small rounded-md', {
          'hover:shadow-medium transition-shadow duration-200': true,
        })}
        src={url}
        layout="responsive"
        height={height}
        width={width}
      />
    </div>
  ) : (
    <></>
  );

  return (
    <div className="sm:mx-0">
      {slug ? (
        <Link href={link} aria-label={title}>
          {image}
        </Link>
      ) : (
        image
      )}
    </div>
  );
}
